var render = function render(){var _vm=this,_c=_vm._self._c;return _c('EvaluationActionIndicator',{attrs:{"icon":"sr-2 sr-v2-eye-slashed","bg-color":"bg-orange-300"}})
}
var staticRenderFns = []

export { render, staticRenderFns }